module.exports = __webpack_public_path__ + "5928.123a75ca8367787ab6b3074566f83780.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/5928.png
// module id = 494
// module chunks = 0